import {
  BasicQuestionType,
  FormField,
  FormFieldInputType,
  QuestionBlock,
  FieldRecord,
} from "../FormTypes";
import { hasConditionalLogic } from "./conditionalLogic";

// prettier-ignore
export const BLOCK_INPUT_TYPES: Record<BasicQuestionType, FormFieldInputType> = {
  "short_text": "text",
  "first_name": "text",
  "last_name": "text",
  "checkboxes": "multi-select",
  "date": "date",
  "date_of_birth": "dob",
  "dropdown": "select",
  "email": "email",
  "file_upload": "file",
  "legal": "checkbox",
  "long_text": "textarea",
  "yes_no": "radio",
  "nps": "nps",
  "number": "text",
  "multi_choice": "radio",
  "scale": "agree_disagree",
  "ranking": "ranking",
  "star_rating": "star_rating",
  "phone": "phone"
}

export const buildFieldFromBlock = (block: QuestionBlock): FormField => {
  return {
    ...block,
    field_key: block.id.toString(),
    writeToAttribute: (block.attributes ?? [])[0]?.token ?? null,
    required: block.required,
    input_type: BLOCK_INPUT_TYPES[block.block_type],
    visible: !hasConditionalLogic(block), // Initialise conditional fields as hidden
    currentValue: null,
    status: "pending" as const,
    validationErrors: null,
    pageIdx: block.pageIdx ?? -1, // This fallback should never occur
    isPrefilled: false,
  } as FormField;
};

export const buildFieldsReducerCallback = (
  acc: FieldRecord = {},
  q: QuestionBlock
): FieldRecord => {
  const field: FormField = buildFieldFromBlock(q);

  return {
    ...acc,
    [field.field_key]: field,
  };
};
